import { mapGetters, mapMutations } from 'vuex';
import {  getAccessLevel, parseFormDate, defaultValue, findProductsOnGivenDate } from '@/utils';
import { VUEX_GENERAL, VUEX_LIMITS_AND_USAGE } from '@/constants/VuexConstants';

export default {
  computed: {
    ...mapGetters({
      policyNumber: VUEX_GENERAL.GETTERS.getCurrentPolicyNumber,
      membershipInfo: VUEX_GENERAL.GETTERS.getMembershipInfo,
      currentMemberDetail: VUEX_GENERAL.GETTERS.getCurrentMemberDetails,
      memberships: VUEX_GENERAL.GETTERS.memberships,
      members: VUEX_GENERAL.GETTERS.getMembers,
    }),

    ...mapGetters('LimitsUsage', {
      memberHistory: VUEX_LIMITS_AND_USAGE.GETTERS.getMemberHistory,
    }),

    accessLevel() {
      // Get the accessLevel of the current logged in member
      return getAccessLevel(this.policyNumber, this.memberships)?.toLowerCase();
    },
  },

  methods: {
    ...mapMutations([VUEX_GENERAL.MUTATIONS.updateMembershipInfo, VUEX_GENERAL.MUTATIONS.updateMembers]),

    ...mapMutations('LimitsUsage', {
      resetLimitAndUsage: VUEX_LIMITS_AND_USAGE.MUTATIONS.resetLimitsAndUsage,
      updateMemberHistory: VUEX_LIMITS_AND_USAGE.MUTATIONS.updateMemberHistory,
    }),

    parseFormDate,
    findProductsOnGivenDate,
    defaultValue,
  },
};
